export default __webpack_public_path__ + "static/dx-decoupled-631742d734771099cc24046df786ed64.png";